import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { LoginResponseModel } from '../models/classes/loginresponse';

@Injectable()
export class AuthValidationInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);
  constructor(private loginService: LoginService, private router: Router) {}
  private hadleError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401) {
      this.router.navigateByUrl('');
    }
    return throwError(err);
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('jwt');
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
    return next.handle(req).pipe(
      catchError((err) => {
        if (
          err instanceof HttpErrorResponse &&
          !req.url.includes('userlogin/login') &&
          err.status === 401
        ) {
          return this.handle401Error(req, next);
        }
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      // this.refreshTokenSubject.next(null);
      let refreshmodel = new LoginResponseModel();
      refreshmodel.token = localStorage.getItem('jwt');
      refreshmodel.refreshToken = localStorage.getItem('refresh');
      return this.loginService.refresh(refreshmodel).pipe(
        switchMap((data: LoginResponseModel) => {
          this.isRefreshing = false;
          localStorage.setItem('jwt', data.token);
          localStorage.setItem('refresh', data.refreshToken);
          this.refreshTokenSubject.next(data.token);

          return next.handle(this.addTokenHeader(request, data.token));
        }),
        catchError((err: HttpErrorResponse) => {
          if (err.status == 401) {
            this.router.navigateByUrl('');
          }
          this.isRefreshing = false;
          return throwError(() => err);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => {
          localStorage.setItem('jwt', token);
          return next.handle(this.addTokenHeader(request, token!));
        })
      );
    }
  }
  private addTokenHeader(
    request: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
  }
}
